var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container-with-title',{attrs:{"title":"Clasificaciones","subtitle":"Ordenadas de acuerdo a cuántos QMIs tienen sin tener asociado un QMP de QMatch."}},[_c('v-classifications-search'),_c('v-classifications-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }